export default __webpack_public_path__ + "assets/models/e1f5a116355c50f6f9f6a00d5b5a3619.glb";